/**
 * useActionHistory.js - Hook para manejar el historial de acciones
 */
import { useState, useCallback } from 'react';

export const useActionHistory = (currentUser) => {
  const [history, setHistory] = useState([]);

  const addToHistory = useCallback((action, details = null) => {
    const newEntry = {
      id: Date.now() + Math.random(), // ID único
      action: action,
      user: currentUser?.email?.split('@')[0] || 'Admin',
      time: new Date(),
      details: details
    };
    
    setHistory(prev => [newEntry, ...prev].slice(0, 50)); // Mantener máximo 50
  }, [currentUser]);

  const clearHistory = useCallback(() => {
    setHistory([]);
  }, []);

  const getFilteredHistory = useCallback((filter) => {
    if (!filter) return history;
    
    return history.filter(item => 
      item.action.toLowerCase().includes(filter.toLowerCase())
    );
  }, [history]);

  return {
    history,
    addToHistory,
    clearHistory,
    getFilteredHistory
  };
};